import React from 'react'

export const ArrowRightCircleIcon = ({ className }: { className?: string }) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <title>Arrow right</title>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.93056 4.98809L8.51219 8L5.93056 11.0119L7.06944 11.9881L10.4878 8L7.06944 4.0119L5.93056 4.98809Z'
      fill='currentColor'
    />
  </svg>
)
